import i18n from "@/common/translations/i18n";
import axios from "axios";
import {LANGUAGE, PLATFORMS} from "@/common/utils/constants";
const URL = process.env.VUE_APP_BACKEND_API_URL;
import router from '@/common/router';

export function addDrcStatistic(props) {
	validateParams(props, PLATFORMS.DRC);
	addDefaultValues(props, PLATFORMS.DRC);
	sendDrcStatistic(props);
}

export function addGopStatistic(props) {
	validateParams(props, PLATFORMS.GOP);
	addDefaultValues(props, PLATFORMS.GOP);
	sendGopStatistic(props);
}

function validateParams(props, platform) {
	const action = props['action'];

	if (!action || action.trim() === "") {
		console.error("The 'action' can't be null, undefined or empty")
	}

	const language = platform === PLATFORMS.DRC ? props['language'] : props.languageId;
	if (language) {
		console.error("Is not allowed to add manually the language")
	}
}

function addDefaultValues(props, platform) {
	if (platform === PLATFORMS.DRC) {
		props.language = {id: LANGUAGE[i18n.locale.toLowerCase()].id};
	} else {
		props.languageId = LANGUAGE[i18n.locale.toLowerCase()].id;
	}
}

function sendDrcStatistic(props) {
	axios.post(`${URL}/statistics`, props);
}

function sendGopStatistic(props) {
	axios.post(`${URL}/gop/statistics`, props);
}

export function getPreviousRoute() {
	const home = window.location.href.includes("/gop") && router.previousRoute.fullPath === "/" ? "/gop/home" : "/home"
	return router.previousRoute.fullPath === "/" ? home : router.previousRoute.fullPath;
}

export function setLastClickedOn(lastClickedOn) {
	localStorage.setItem('lastClickedOn', `${lastClickedOn}`)
}

export function getLastClickedOn() {
	localStorage.getItem('lastClickedOn')
}

export const ACTIONS = {
	DRC: {
		DOWNLOAD: {
			WORD: "WORD",
			POWER_POINT: "POWER_POINT",
			POWER_POINT_SHORT: "POWER_POINT_SHORT",
			PDF: "PDF"
		},
		VIEW: "VIEW"
	},
	GOP: {
		FILE_DOWNLOAD: "gop_file_download",
		DOCUMENT_TYPE: {
			PDF: 'pdf',
			PPT: 'ppt'
		},
		SEARCH: "gop_search_visit",
		"gop_sector_visit": "gop_sector_visit",
		"gop_offer_visit": "gop_offer_visit",
	},
	COMMON: {
		USER_LOGIN_SSO: "user_login_sso",
		USER_LOGIN_GUEST: "user_login_guest",
		SAVE: "SAVE",
		UNSAVE: "UNSAVE",
		COPY_LINK: "COPY_LINK",
		REPORT_PROBLEM: "REPORT_PROBLEM",
		SEARCH_PAGE: 'SEARCH_PAGE'
	}
}
